import { Component, OnInit } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'app-nonsellable-dialog',
  templateUrl: './nonsellable-dialog.component.html',
  styleUrls: ['./nonsellable-dialog.component.scss'],
})
export class NonsellableDialogComponent implements OnInit {
  nonSellableProducts: any[]

  nonSellableArr: any[]

  constructor(private launchDialogService: LaunchDialogService) {}

  ngOnInit(): void {
    this.launchDialogService.data$.subscribe((data) => {
      this.nonSellableProducts = data.nonSellableProducts
    })
    this.nonSellableArr = this.nonSellableProducts.filter(
      (n, i) => this.nonSellableProducts.indexOf(n) === i
    )
  }

  closeModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.NON_SELLABLE,
      reason: 'submit-fav',
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
